import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BrandContextService } from '../services/brand-context.service';

export const brandIdInterceptor: HttpInterceptorFn = (req, next) => {
  // Only attach the header to calls targeting our own API
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const brandId = inject(BrandContextService).brandId();
  if (!brandId) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'x-hohr-brand-id': brandId } }));
};
